import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Label } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-regular-svg-icons';
//Components
import MainCard from '../../components/MainCard/MainCard';
import TextField from '../../components/TextField/TextField';
import RichTextEditor from '../../components/RichTextEditor';
import Loading from 'components/Loading/Loading';
//Api
import correioInterno_api from '../../api/correioInterno_api';

//Helpers
import { showMessage } from '../../helpers/message';
import { validarCampos, objCampo } from '../../helpers/ValidadorDeCampos';
import uuid from '../../helpers/guid';
import mascaras from '../../helpers/mascaras';

//Estado inicial do correio interno
function initalStateCorreioInterno() {
    return {
        titulo: "",
        destinatario: "",
        destinatario_Selected: [],
        mensagem: "",
        anexos: [],
        tipoEnvio: "Interno",
        destinatarioEnvio: null
    }
}
export default function NovoCorreioInterno({ btnVoltar }) {
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState();

    //Estado que guarda os erros nos campos do formulario
    const [errors, setErrors] = useState({});

    //Campos obrigatorios do formulario
    const camposObrigatorios = [
        objCampo({ name: "titulo", required: true }),
        objCampo({ name: "destinatario_Selected", required: true }),
        objCampo({ name: "mensagem", required: true }),
    ];

    //Opções dos selects de TipoEnvio 
    const optionsTipoEnvio = [
        { text: "Interno", value: "Interno" },
        { text: "Email", value: "Email" },
        { text: "Ambos", value: "Ambos" }
    ];

    //Estado de controle dos dados do correio interno
    const [correioInterno, setCorreioInterno] = useState(initalStateCorreioInterno);

    //Opções do multiselect de destinatarios
    const optionsDestinatario = [
        { label: "Destino", value: "DESTINO" },
        { label: "Gerador", value: "GERADOR" },
        { label: "Transportador", value: "TRANSPORTADOR" },
    ];

    const [listaDestinatarios, setListaDestinatarios] = useState([]);

    //Change para os campos do correio interno
    const onChangeCorreio = (e) => {
        const { name, value } = e.target;
        const _correioInterno = {
            ...correioInterno,
            [name]: value
        };
        const campo = camposObrigatorios.filter(value => value.name === name);
        const erroCampo = validarCampos(_correioInterno, campo);
        if (erroCampo[1].length > 0) {
            setErrors({ ...errors, ...erroCampo[0] });
        } else {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors(_errors);
        }
        setCorreioInterno(_correioInterno);
    }

    //Change para o select de destinatario
    const onChangeDestinatario = (e, select) => {
        const { name } = select;
        const valueDestinatario = e.map(item => {
            return item.value;
        })
        const _correioInterno = {
            ...correioInterno,
            [name]: e,
            [name.split("_")[0]]: valueDestinatario.toString().replaceAll(",", "|")
        };
        const campo = camposObrigatorios.filter(value => value.name === name);
        const erroCampo = validarCampos(_correioInterno, campo);
        if (erroCampo[1].length > 0) {
            setErrors({ ...errors, ...erroCampo[0] });
        } else {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors(_errors);
        }

        setCorreioInterno(_correioInterno);
    }

    //Função que cadastra/edita um correio interno
    const onSubmit = () => {
        const _errors = validarCampos(correioInterno, camposObrigatorios);
        setErrors(_errors[0]);
        if (_errors[1].length > 0) {
            return;
        }
        setLoading(true);
        correioInterno_api.Post(correioInterno).then(response => {
            showMessage("Sucesso", "Correio interno criado com sucesso!", "success", btnVoltar);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));

    }

    //OnChange para o anexo da recusa da entrada
    const onChangeAnexo = (e) => {
        const anexo = { nome: "", base64: "" };
        anexo.nomeArquivo = e.target.files[0].name;
        anexo.nome = e.target.files[0].name;
        const FR = new FileReader();

        FR.addEventListener("load", function (evt) {
            anexo.base64 = evt.target.result.split("base64,")[1];
            anexo.nome = anexo.nome.split(".");
            anexo.nome = uuid() + "." + anexo.nome[anexo.nome.length - 1];
            setCorreioInterno({
                ...correioInterno,
                anexos: [...correioInterno.anexos, anexo]
            });

        });

        FR.readAsDataURL(e.target.files[0]);
    }

    //Remove um dos anexos que foram adicionados
    const removerAnexo = (index) => {
        const _correioInterno = {
            ...correioInterno
        }
        _correioInterno.anexos.splice(index, 1);
        setCorreioInterno(_correioInterno);
    }

    //onChange para a questão vinculada
    const onChangeCorreioInternoSearchable = (e, select) => {
        setCorreioInterno({
            ...correioInterno,
            [select.name]: e != null ? e.value : null
        })
    }

    useEffect(() => {
        if (correioInterno?.destinatario_Selected?.length > 0) {
            const valueDestinatario = correioInterno.destinatario_Selected.map(item => {
                return item.value;
            })

            let json_submit = {
                destinatario: valueDestinatario.toString().replaceAll(",", "|")
            };

            setCorreioInterno({
                ...correioInterno,
                destinatarioEnvio: null
            });

            setLoading(true);
            correioInterno_api.GetDestinatarios(json_submit)
                .then(response => {
                    response.data = response.data.map(value => {
                        value.label = mascaras.cpfcnpjMask(value.cpfcnpj) + " | " + value.nomeFantasia + " | " + value.categoria;
                        value.value = value.id;
                        return value;
                    })
                    setListaDestinatarios(response.data)
                }).catch(e => showMessage("Aviso", e.message, "error", null))
                .finally(f => setLoading(false));

        } else
            setListaDestinatarios([])
    }, [correioInterno.destinatario_Selected]);

    return (
        <MainCard title={"Novo correio interno"} btnVoltarInTop={btnVoltar}>
            {loading && <Loading />}
            <Row>
                <Col md="12" lg="4">
                    <TextField label={"* Titulo"}
                        onChange={onChangeCorreio}
                        name={"titulo"}
                        value={correioInterno.titulo}
                        invalid={errors.titulo ? true : false}
                    />
                </Col>
                <Col md="12" lg="4">
                    <TextField
                        label={"Tipo Envio"}
                        type="select"
                        options={optionsTipoEnvio}
                        name="tipoEnvio"
                        value={correioInterno.tipoEnvio}
                        onChange={onChangeCorreio}
                    />
                </Col>
                <Col md="12" lg="4">
                    <TextField
                        label={"* Destinatario"}
                        type={"select"}
                        multiple
                        options={optionsDestinatario}
                        onChange={onChangeDestinatario}
                        value={correioInterno.destinatario_Selected}
                        name={"destinatario_Selected"}
                        invalid={errors.destinatario_Selected ? true : false}
                    />
                </Col>
                <Col md="12" lg="12">
                    <TextField
                        label={"Selecionar Destinatário"}
                        type="select"
                        options={listaDestinatarios}
                        name="destinatarioEnvio"
                        searchable
                        placeholder='Todos'
                        value={listaDestinatarios?.filter(x => x.value == correioInterno.destinatarioEnvio)[0]}
                        onChange={onChangeCorreioInternoSearchable}
                    />
                </Col>
                <Col md="12" lg="12">
                    <Label className='text-secondary'>* Mensagem</Label>
                    <RichTextEditor
                        name="mensagem"
                        value={correioInterno.mensagem}
                        onChange={onChangeCorreio}
                        invalid={errors.mensagem ? true : false}
                    />
                </Col>
                <Col md="12" lg="12">
                    <TextField
                        label={"Anexo"}
                        type={"file"}
                        onChange={onChangeAnexo}
                        name={"anexo"}
                    />
                </Col>
                {correioInterno.anexos.map((value, index) => {
                    return (
                        <Col md="6" lg="2" className='mt-4'>
                            <div className='border text-secondary p-2 shadow d-flex flex-column align-items-center justify-content-center rounded-3 position-relative'>
                                <button color='danger' className="cancelFileButton" onClick={() => removerAnexo(index)}>
                                    X
                                </button>
                                <FontAwesomeIcon size='4x' icon={faFileAlt} />
                                <p className='m-0 mt-2 fw-bold'>{value.nomeArquivo}</p>
                            </div>
                        </Col>
                    )
                })}
            </Row>
            <div className='d-flex align-items-center justify-content-center mt-4' >

                <Button onClick={onSubmit} color={"success"} className='bg-gradient'>{<>+ Adicionar</>}</Button>
            </div>
        </MainCard >
    )
}